import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { DownloadTray } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { Button } from '../Button/Button';
import { Card } from '../Card/Card';
import { FileDropzone } from '../FileDropzone/FileDropzone';
import { Column, Row } from '../Layout';
import { Typography } from '../Typography/Typography';
import styles from './CsvStage.module.scss';
import { DropzoneContent } from './DropzoneContent';
const CSV_MIME_TYPES = '.csv,text/csv';
export const GetCsvStageTID = (parentTestId)=>getTestIds(parentTestId);
/**
 * The two-card CSV round trip: download a pre-filled file, then drop the filled-in one back.
 * Copy, schema preview and BI names all arrive as props, so a second stage reuses it unchanged.
 */ export const CsvStage = (param)=>{
    let { texts, schemaPreview, uploadError, isDownloading, isUploading, uploadDisabled, onDownload, onFileSelected, bi, testId } = param;
    const { CsvStageTestIds: TID } = useMemo(()=>GetCsvStageTID(testId), [
        testId
    ]);
    const renderDropzone = ()=>/*#__PURE__*/ _jsx(DropzoneContent, {
            title: texts.dropzoneTitle,
            hint: texts.dropzoneHint,
            limit: texts.dropzoneLimit,
            isUploading: isUploading,
            testId: TID.Dropzone()
        });
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        testId: TID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Card, _object_spread_props(_object_spread({}, bi.downloadCard), {
                skin: "white",
                borderSkin: "default",
                borderRadius: "ml",
                padding: "sm",
                shadow: "none",
                testId: TID.DownloadCard(),
                children: /*#__PURE__*/ _jsxs(Row, {
                    gap: 14,
                    alignItems: "start",
                    children: [
                        /*#__PURE__*/ _jsx(Row, {
                            className: styles.badge,
                            alignItems: "center",
                            justifyContent: "center",
                            children: /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph2",
                                children: "1"
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Column, {
                            gap: 4,
                            grow: true,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph1",
                                    weight: "normal",
                                    children: texts.downloadTitle
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    className: styles.downloadBody,
                                    variant: "paragraph2",
                                    skin: "secondary",
                                    children: texts.downloadBody
                                }),
                                schemaPreview,
                                /*#__PURE__*/ _jsx(Row, {
                                    className: styles.downloadAction,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        skin: "primaryOutline",
                                        size: "medium",
                                        prefixIcon: /*#__PURE__*/ _jsx(DownloadTray, {
                                            size: 18
                                        }),
                                        loading: isDownloading,
                                        bi: bi.download,
                                        testId: TID.Download(),
                                        onClick: onDownload,
                                        children: texts.downloadButton
                                    })
                                })
                            ]
                        })
                    ]
                })
            })),
            /*#__PURE__*/ _jsx(Card, _object_spread_props(_object_spread({}, bi.uploadCard), {
                skin: "white",
                borderSkin: "default",
                borderRadius: "ml",
                padding: "sm",
                shadow: "none",
                testId: TID.UploadCard(),
                children: /*#__PURE__*/ _jsxs(Row, {
                    gap: 14,
                    alignItems: "start",
                    children: [
                        /*#__PURE__*/ _jsx(Row, {
                            className: styles.badge,
                            alignItems: "center",
                            justifyContent: "center",
                            children: /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph2",
                                children: "2"
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Column, {
                            gap: 12,
                            grow: true,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph1",
                                    weight: "normal",
                                    children: texts.uploadTitle
                                }),
                                /*#__PURE__*/ _jsx(FileDropzone, {
                                    accept: CSV_MIME_TYPES,
                                    className: styles.dropzone,
                                    disabled: isUploading || uploadDisabled,
                                    bi: bi.upload,
                                    testId: TID.Dropzone(),
                                    onFileSelected: onFileSelected,
                                    renderContent: renderDropzone
                                }),
                                /*#__PURE__*/ _jsx(Column, {
                                    testId: TID.UploadError(),
                                    children: uploadError
                                })
                            ]
                        })
                    ]
                })
            }))
        ]
    });
};
